import {
  SubMenuContainer,
  SubMenuLinkWrapper,
  SubMenuList,
  SubMenuListItem,
} from "./styles";
import "./SubMenu.css";
import React from "react";
import PropType from "prop-types";

export default function SubMenu(props) {
  if (props.wide) {
    return (
      <div
        className={
          "sub-menu-wide-container " +
          (props.display
            ? "sub-menu-wide-container-show"
            : "sub-menu-wide-container-hide")
        }
        onMouseLeave={props.onMouseLeave}
      >
        {Object.entries(props.subNavLinks).map(([key, links]) => {
          return (
            <div key={key} className="sub-menu-wide-group">
              <h3 className="sub-menu-group-title noselect">{key}</h3>
              {links.map((subNavLink, index) => {
                return (
                  <a
                    className="sub-menu-wide-link-wrapper"
                    key={index}
                    href={subNavLink.url}
                  >
                    <div className="sub-menu-wide-item">{subNavLink.title}</div>
                  </a>
                );
              })}
            </div>
          );
        })}
      </div>
    );
  }

  return (
    <SubMenuContainer
      displaySubMenu={props.display}
      onMouseLeave={props.onMouseLeave}
    >
      <SubMenuList>
        {props.subNavLinks.map((subNavLink, index) => {
          return (
            <SubMenuLinkWrapper key={index} href={subNavLink.url}>
              <SubMenuListItem>{subNavLink.title}</SubMenuListItem>
            </SubMenuLinkWrapper>
          );
        })}
      </SubMenuList>
    </SubMenuContainer>
  );
}

SubMenu.propTypes = {
  display: PropType.bool.isRequired,
  onMouseLeave: PropType.func,
  subNavLinks: PropType.arrayOf(PropType.object),
};
